import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  computed,
  defineEmits,
  watch,
  withDefaults,
  defineProps,
} from "../TUIKit/adapter-vue";
import {
  TUIStore,
  StoreName,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import Icon from "../TUIKit/components/common/Icon.vue";
import Avatar from "../TUIKit/components/common/Avatar/index.vue";
import messageWebSVG from "../assets/icon/message.svg";
import messageH5SVG from "../assets/icon/message-real.svg";
import messageSelectedSVG from "../assets/icon/message-selected.svg";
import relationWebSVG from "../assets/icon/relation.svg";
import relationH5SVG from "../assets/icon/relation-real.svg";
import relationSelectedSVG from "../assets/icon/relation-selected.svg";
import profileH5SVG from "../assets/icon/profile.svg";
import profileSelectedSVG from "../assets/icon/profile-selected.svg";
import settingPNG from "../assets/icon/setting.png";
import { IUserProfile } from "../TUIKit/interface";
import { isPC, isH5 } from "../TUIKit/utils/env";

export interface INavBarItem {
  icon: any;
  h5Icon: any;
  selectedIcon: any;
  name: string;
  label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: {
    currentNavBar: { default: () => "message" },
    isSettingShow: { type: Boolean, default: false }
  },
  emits: ["toggleSettingShow", "switchNavBar"],
  setup(__props: any, { emit: emits }) {

const props = __props as { currentNavBar: string, isSettingShow: boolean }





const currentSettingStatus = ref<boolean>(props.isSettingShow);
const currentSelectedNav = ref(props.currentNavBar);
const navBarListForShow = computed<Array<INavBarItem>>(() => {
  return isPC
    ? navBarList.filter((item: INavBarItem) => item.name !== "profile")
    : navBarList;
});
const avatar = ref<string>("");

TUIStore.watch(StoreName.USER, {
  userProfile: (userProfileData: IUserProfile) => {
    avatar.value = userProfileData?.avatar || "";
  },
});

const navBarList: Array<INavBarItem> = [
  {
    icon: messageWebSVG,
    h5Icon: messageH5SVG,
    selectedIcon: messageSelectedSVG,
    name: "message",
    label: "消息",
  },
  // {
  //   icon: relationWebSVG,
  //   h5Icon: relationH5SVG,
  //   selectedIcon: relationSelectedSVG,
  //   name: "relation",
  //   label: "通讯录",
  // },
  // {
  //   icon: profileH5SVG,
  //   h5Icon: profileH5SVG,
  //   selectedIcon: profileSelectedSVG,
  //   name: "profile",
  //   label: "个人中心",
  // },
];

function toggleSetting() {
  currentSettingStatus.value = !currentSettingStatus.value;
  emits("toggleSettingShow", currentSettingStatus.value);
}

function switchNavBar(name: string) {
  currentSelectedNav.value = name;
  emits("switchNavBar", name);
}

watch(
  () => props.currentNavBar,
  () => {
    currentSelectedNav.value = props.currentNavBar;
  },
  {
    immediate: true,
  }
);
watch(
  () => props.isSettingShow,
  () => {
    currentSettingStatus.value = props.isSettingShow;
  },
  {
    immediate: true,
  }
);

return { __sfc: true,props, emits, currentSettingStatus, currentSelectedNav, navBarListForShow, avatar, navBarList, toggleSetting, switchNavBar, TUITranslateService, Icon, Avatar, isPC, isH5 }
}

})